import * as React from 'react';

import * as styles from './CommercialFactoidsWrapper.css';

export const CommercialFactoidsWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <span className={styles['factoids-wrapper']}>{children}</span>;
};
